var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCeuta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.0107422C11.582 0.0107422 7.58196 1.80162 4.68652 4.69699L16.0003 16.0107V0.0107422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0107C0 20.4291 1.79088 24.4291 4.68625 27.3245L16 16.0107H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C20.4183 32.0107 24.4183 30.2199 27.3137 27.3245L16 16.0107V32.0107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0108C32 11.5925 30.2091 7.59246 27.3137 4.69702L16 16.0108H32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 11.1412L16 11.837L21.5652 11.1412V7.80205L19.3391 8.91512L16 5.57593L12.6609 8.91512L10.4348 7.80205V11.1412Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24.3586C12.9313 24.3586 10.4348 21.862 10.4348 18.7934V13.2285L12.5218 11.1414H19.4783L21.5652 13.2285V18.7934C21.5652 21.862 19.0687 24.3586 16 24.3586Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 22.2716C14.0818 22.2716 12.5215 20.7113 12.5215 18.7934V13.2283H19.478V18.7933C19.478 20.7113 17.9177 22.2716 15.9997 22.2716Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 11.1411H12.5218V13.2281H10.4348V11.1411Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4778 11.1411H21.5647V13.2281H19.4778V11.1411Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4778 15.6628H21.5647V17.7498H19.4778V15.6628Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 15.6628H12.5218V17.7498H10.4348V15.6628Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.2715C15.6365 22.2715 15.2861 22.2152 14.9565 22.1113V24.2589C15.2947 24.3234 15.6432 24.3585 16 24.3585C16.3567 24.3585 16.7052 24.3234 17.0435 24.2589V22.1113C16.7139 22.2151 16.3635 22.2715 16 22.2715Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5683 19.3579L10.9028 21.0234C11.1915 21.6808 11.6035 22.272 12.1099 22.7677L13.5849 21.2927C13.0585 20.7841 12.6918 20.1116 12.5683 19.3579Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0973 21.0237L19.4318 19.3582C19.3081 20.1118 18.9415 20.7842 18.4152 21.293L19.8902 22.768C20.3964 22.2723 20.8085 21.6811 21.0973 21.0237Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3048 14.3877V15.5471C15.3048 15.9312 15.6162 16.2427 16.0004 16.2427C16.3846 16.2427 16.696 15.9312 16.696 15.5471V14.3877H15.3048Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3048 19.0254V20.1848C15.3048 20.5689 15.6162 20.8804 16.0004 20.8804C16.3846 20.8804 16.696 20.5689 16.696 20.1848V19.0254H15.3048Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3917 16.7065V17.866C17.3917 18.2502 17.7031 18.5617 18.0873 18.5617C18.4715 18.5617 18.783 18.2502 18.783 17.866V16.7065H17.3917Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3048 16.7065V17.866C15.3048 18.2502 15.6162 18.5617 16.0004 18.5617C16.3846 18.5617 16.696 18.2502 16.696 17.866V16.7065H15.3048Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 16.7065V17.866C13.2178 18.2502 13.5292 18.5617 13.9134 18.5617C14.2976 18.5617 14.609 18.2502 14.609 17.866V16.7065H13.2178Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCeuta);
export default __webpack_public_path__ + "static/media/flag_ceuta.c534d4202f1433360f2ae0f74fe87bc4.svg";
export { ForwardRef as ReactComponent };